  const lqContent = `
  <!DOCTYPE HTML>
<html lang="en">
    
    <body>

<div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
    
    <div class="html-editor parbase aem-GridColumn aem-GridColumn--default--12">



	 	<head>
    <style type="text/css">
        .ad-section {
            display: flex;
            flex-direction: row;
            flex-flow: wrap;
            background: #000000;
            align-items: center;
            height: 280px;
            font-size: 12px;

        }

        .ad-card {
            width: 30%;
            padding: 20px 25px;
            margin: 14px;
            background-color: #F6F6F6;
            height: 220px;
            border-radius: 2px;
            margin-top: 0px;
        }

        .ad-cardbg {
            width: 30%;
            padding: 20px 25px;
            margin: 14px;
            /* margin-top: 31px; */
            border-radius: 2px;
            background-image: url(images/Desktop_JointOffer_GBOrder_Big-min.png);
            background-repeat: no-repeat;
            background-size: 100% 220px;
            height: 220px;
            margin-top: 0px;
        }

        .ad-card h3,
        .ad-cardbg h3 {
            font-size: 12px;
            font-weight: bolder;
            /*font-family: "Verizon NHG eDS";*/
        }

        .ad-card .header{
           /* font-family: "Verizon NHG eDS";*/
            font-size: 20px;
            letter-spacing: 0;
            line-height: 20px;
            font-weight: bold;
            width: 100%;
            padding: 10px 2px 10px 0px;
        }
        .ad-cardbg .header {
           /* font-family: "Verizon NHG eDS";*/
            font-size: 20px;
            letter-spacing: 0;
            line-height: 20px;
            font-weight: bold;
            width: 80%;
            padding: 10px 2px 10px 0px;
        }

        /*.ad-card p,.ad-cardbg p {
    font-family: "Verizon NHG eDS";
      font-size: 12px;
      letter-spacing: 0;
      line-height: 14.4px
    }*/
        .ad-card a.cta-text,
        .ad-cardbg a.cta-text {
            width: 8px;
            height: 14px;
            /*font-family: "Verizon NHG eDS";*/
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 0.5px;
            line-height: 20px;
            cursor: pointer;
            color: black;
            text-decoration: none;
        }

        .ad-descr {
            width: 30%;
            color: #FFFFFF;
            height: 91.2px;
            font-weight: bold;
            font-size: 30px;
            letter-spacing: 0px;
            line-height: 32px;
            padding: 0px 0px;
            margin-left: 10px;
            margin-right: 40px;
        }
        .modal-overlay {
            position: fixed;
            z-index: 999;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: rgb(0,0,0,0.8);
        }

        .modal {
            position: relative;
            padding-top: 20px;
            left: 25%;
            top: 10%;
            width: 50%;
            height: auto;
            overflow: auto;
            background: white;
            color: rgb(0, 0, 0);
            margin: 0;
            padding: 20px;
            border: 1px solid #888;
            box-shadow: 0 4px 8px 0;
            text-decoration: none;

        }

        .modal-content {

            position: relative;
            max-height: 65vh;
            overflow-y: scroll;
        }

        .modal-content .head1 {
            font-size: 24px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 24px;
        }

        .modal-content .head2 {
            font-size: 14px;
            font-weight: bold;
            letter-spacing: 0.5px;
            line-height: 20px;
        }

        .modal-content .descr {
            font-size: 14px;
            letter-spacing: 0.5px;
            line-height: 20px;
        }

        .modal-content > ul {
            margin: 0;
            padding-inline-start: 20px;
            margin-bottom: 20px;
        }

        .modal-content > ul ul {
            list-style-type: disc;
            margin-top: 10px;
        }

        .close {
            color: #aaaaaa;
            float: right;
            font-size: 20px;
            font-weight: bold;
        }

        .close:hover,
        .close:focus {
            color: black;
            cursor: pointer;
        }

        .mb15 {
            margin-bottom: 10px;
        }
        .mb20 {
            margin-bottom: 20px;
        }
        .mb30 {
            margin-bottom: 30px;
        }
        .mb40 {
            margin-bottom: 40px;
        }

        .ad-cardbg a:after, .ad-card a:after {
            content: '';
            background-image: url(https://www.verizon.com/content/dam/verizon/business/gbcom/Arrow-black.svg);
            background-repeat: no-repeat;
            width: 8px;
            height: 14px;
            position: absolute;
            /*top: calc(50% - 26px);*/
            /* right: 17px; */
            margin-left: 10px;
            margin-top: 4px;
        }
        
        /* #offer-modal{
            width: 600px;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -40%);
            padding: 40px;
            max-height:80vh;
        }
        #offer-modal .head1 {
          font-size:32px!important;
        }
        #offer-modal .modal-content {
          max-height:60vh;
        }
        #offer-modal .close {
          color: #000;
          float: right;
          font-size: 36px;
          font-weight: bold;
          margin-top: -5px;
        } */
        .modal .head1 {
          font-size:20px !important;
          margin-top:0;
        }
        .modal .close {
          color: #000;
          float: right;
          font-size: 36px;
          font-weight: bold;
          margin-top: -10px;
        }

        @media only screen and (max-width: 48rem) {
            .ad-cardbg a:after, .ad-card a:after {
                content: '';
                background-image: url(https://www.verizon.com/content/dam/verizon/business/gbcom/Arrow-black.svg);
                background-repeat: no-repeat;
                width: 8px;
                height: 14px;
                position: absolute;
                /*top: calc(50% - 154px);
             right: 17px; */
                margin-left: 6px;
            }

            .modal {
                left: 0px;
                top: 16px;
                width: 92%;
                height: 95%;
                overflow: auto;
                padding: 20px;
                margin: auto;
            }
            .modal-content {
                max-height: 90%;
            }

            .ad-section {
                display: flex;
                flex-direction: column;
                flex-flow: wrap;
                background: #000000;
                align-items: center;
                height: fit-content;

            }

            .ad-card {
                width: 95% !important;
                height: auto;
            }

            .ad-cardbg {
                width: 95%;
               /* margin-left: 0.5rem !important;*/
                background-image: url(images/Mobile_JointOffer_GBOrder_Big-min.png);
                background-repeat: no-repeat;
                background-size: 100% 100%;
                height: auto;
            }

            .ad-descr {
                width: 95%;
                height: fit-content;
                padding: 20px 0px 10px 16px;
                margin-left: 2px;
            }

            .ad-card .header,
            .ad-cardbg .header {
                   padding-top: 10px;
					font-size: 27px !important;
					line-height: 28px;
					font-weight: bold;
					width: 75%;
					padding: 20px 0px 15px 0px;
            }
            /* #offer-modal{
                width: 95%;
                padding: 20px;
                transform: translate(-50%, -62%);
            }
            #offer-modal .head1 {
                font-size:20px !important;
            }
            .modal-content .descr {							
                padding-right: 10px;
            } */
            .modal .head1 {
                font-size:20px !important;
                width: 90%;
            }
        }
          @media only screen and (min-width: 768px) and (max-width: 1023px) {
            .ad-descr {
                width: 95%;
                padding: 10px 0px 10px 16px;
            }

           .ad-cardbg {
                width: 95%;
                /* margin-left: 0.5rem !important; */
                background-image: url(images/Desktop_JointOffer_GBOrder_Big-min.png);
                background-repeat: no-repeat;
                background-size: 100% 100%;
                /* height: 275px; */
            }
            /*.ad-section {
                height: fit-content;
            }*/
            .modal-content .descr {							
                padding-right: 10px;
            }
			 .modal {
                left: 0px;
                top: 16px;
                width: 92%;
                height: 95%;
                overflow: auto;
                padding: 20px;
                margin: auto;
            }
            .modal-content {
                max-height: 90%;
            }
            
        }

        @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px){
           .ad-section {
               height: 320px
           }
           .ad-descr {
            margin-right: 30px;
           }
           .ad-card {
               height: 240px;
           }
           .ad-cardbg {
               height: 240px;
               background-size: 100% 240px;
           }
            
        }

        @media screen and (max-width: 1024px) and (min-width: 768px) and (orientation: landscape) {
            .ad-descr {
                width: 30%;
                font-size: 32px;
                line-height: 32px;
                height: fit-content;
                padding: 8px 0px 10px 16px;
				margin-right: 10px;
            }
			.ad-card{               
                height: 240px;	
				padding: 20px 17px;
            }

            .ad-cardbg {
                background-repeat: no-repeat;
                background-size: 100% 240px;
                height: 240px;
				width: 30%;
				padding: 20px 14px;
            }
			.ad-cardbg .header {
                padding-top: 10px;
                font-size: 20px;
                line-height: 20px;
                font-weight: bold;
                width: 80%;
                padding: 16px 2px 0px 0px;
				margin-bottom: 20px;
            }

           /* .ad-section {
                height: fit-content;
            }*/
            .modal-content .descr {							
                padding-right: 10px;
            }
			 .modal {
                left: 0px;
                top: 16px;
                width: 92%;
                height: 95%;
                overflow: auto;
                padding: 20px;
                margin: auto;
            }
            .modal-content {
                max-height: 90%;
            }
        }
    </style>
</head>

<body>
    <div class="ad-section">
        <div class="ad-descr">
            Enter your address above to see if you qualify for these online offers.
        </div>
        <div class="ad-card">
            <h3>Exclusive online offer ends 11.14.22</h3>
            <div class="header">Select a Fios internet and phone bundle to get up to a $500 Visa® Prepaid card.</div>
            <div class="mb30">Exclusive online offer for new customers that bundle Fios internet and phone with a 2-yr agreement.</div>
            <a class="modal-text cta-text" data-target="offer-modal" data-toggle="modal" href="#" id="offerlink">Learn how </a>
        </div>
       <div class="ad-cardbg">
			<h3>Online joint offer</h3>
            <div class="header mb40">Save up to $80/mo when you combine Fios business internet with Business Wireless Unlimited plan</div>
            <a class="modal-text cta-text" data-target="offer-modal2" data-toggle="modal" id="offerlinktwo">Learn how </a>
        </div>
    </div>
    <div id="offer-modal" class="modal-overlay" style="display: none;">
        <div class="modal fade" role="dialog" style="overflow: hidden">
            <span class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">&times;</span>
            <h3 class="head1 mb20">How to qualify for the Visa® Prepaid Card Offers</h3>
            <div class="modal-content">
                <ul class="descr">
                    <li>
                        <span>Businesses who sign up for a double bundle, with our Fios Internet with a two year agreement will receive a Visa® Prepaid Card, with the Visa® Prepaid Card amount based on speed tier purchased and availability of that speed tier in a geographic area.</span>
                    </li>
                </ul>
                <div class="head2 mb15">Details to keep in mind</div>
                <ul class="descr">
                    <li>Businesses who sign up for a qualifying Fios bundle entirely online (where the order is started and completed online) are eligible to have the value of their Visa® Prepaid Card increased by $100. May only be combined with select offers.</li>
                    <li>Verizon Visa® Prepaid Card issued by Pathward, Member FDIC, pursuant to a license from Visa U.S.A. Inc. Use everywhere Visa debit cards are accepted. This optional offer is not a Pathward product or service and Pathward neither endorses nor sponsors it.</li>
                    <li>Must register for card online and keep qualifying Verizon service for 60 days from install, with no past-due balance 65 days from install. Card mailed within 90 days of install date. Limit one card per account. Other card terms and conditions apply.</li>
                </ul>
            </div>
        </div>
    </div>
    <div id="offer-modal2" class="modal-overlay" style="display: none;">
        <div class="modal fade" role="dialog" style="overflow: hidden">
            <span class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">&times;</span>
            <h3 class="head1 mb20">Take advantage of this offer and save more</h3>
            <div class="modal-content">
                <div class="descr mb20">To qualify you will need to have a Verizon Business Unlimited wireless plan and a Fios business internet plan. Read the step details below to see how.</div>
                <div class="head2 mb15">Are you an existing Verizon Business Unlimited Wireless customer?</div>
                <ul class="descr">
                    <li>Enter your address to see if Fios Business Internet is available in your area.</li>
                    <li>If Fios service is available, check if your business wireless number is eligible when you begin your order.</li>
                    <li>Once you check eligibility, proceed to customize your cart and checkout to submit your order.</li>
                    <li>Once your service is installed, you will see the discount in your monthly bill within 1-2 billing cycles.</li>
                </ul>
                <div class="head2 mb15">Are you a new customer for both Fios internet and wireless service?</div>
                <ul class="descr">
                    <li>Start by entering your address to see if Fios Business Internet is available in your area.</li>
                    <li>If Fios service is available, select your internet plan or bundle.</li>
                    <li>Once you complete checkout and submit your order, chat with a Sales representative to purchase a Wireless Business Unlimited plan.</li>
                </ul>
                <div class="head2 mb15">Important legal information</div>
                <div class="descr mb15">
                    Offer available to new and existing business customers in select areas only who sign up for both: (i) a qualifying Fios Business Internet plan & (ii) a qualifying Verizon Wireless Business Unlimited plan (eligible smartphone required, device payment purchase or bring your own device). Existing customers are eligible with Fios Business Internet plan upgrade or Business Unlimited plan upgrade or a new line, as applicable. Customers with Fios Gigabit Connection (speeds up to 940/880 Mbps) and Verizon Wireless Business Unlimited Pro plan (at least 1 line) are eligible for a total credit of $80/mo, all other combinations of service plans are eligible for a total credit of $40/mo. Offer fulfilled as a credit of $20/mo. or $40/mo. each to your Fios and Verizon Wireless bills, for a total credit of $40/mo or $80/mo as applicable. Credit is fulfilled at an account level and only one promotional credit per account. Discounts are applied once both services are activated. All discounts apply as long as Verizon provides & business maintains both services at the qualifying levels. Limited time offer.
                </div>
            </div>
        </div>
    </div>
    <script type="text/javascript">
        var modal = document.getElementById("offer-modal");
        var content = document.getElementById("offerlink");
        var span = document.getElementsByClassName("close")[0];

        //for second modal
        var modal2 = document.getElementById("offer-modal2");
        var contenttwo = document.getElementById("offerlinktwo");
        var span2 = document.getElementsByClassName("close")[1];
        // for moving modal code to body tag
        var docBody = document.getElementsByTagName("body")[0];
        docBody.appendChild(modal);
        docBody.appendChild(modal2);
        content.onclick = function () { 
            modal.style.display = "block";
            resetScrollPosAem('.modal-content');
        }
        contenttwo.onclick = function () {
            modal2.style.display = "block";
            resetScrollPosAem('.modal-content');
        }
        span.onclick = function () { modal.style.display = "none"; }
        span2.onclick = function () { modal2.style.display = "none"; }
        window.onclick = function (event) {
            if (event.target == modal) {
                modal.style.display = "none";
            }
            if (event.target == modal2) {
                modal2.style.display = "none";
            }
        }
        function resetScrollPosAem(selector) {
            var divs = document.querySelectorAll(selector);
            for (var p = 0; p < divs?.length; p++) {
                divs[p].scrollTop = 0;
            }
        }
    </script>
</body>


<div class="clr"></div>

</div>

    
</div>
</body>
</html>
`

export default lqContent;
 
        
